(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
ga && ga('create', 'UA-34913398-1', 'auto');
ga && ga('set', 'dimension1', 'client');
ga && ga('send', 'pageview');

window.onload = function () {
    $nuxt.$router.afterEach(() => {
        ga && ga('send', 'pageview');
    });
};
